import React, { useCallback, useEffect, useState } from "react";
import PurchaseReturnGeneral from "./PurchaseReturnGeneral";
import {
  DOCUMENT_TYPES,
  fetchDocumentNumber,
  fetchUnitOptionsForItems,
  getDocumentConfig,
  MODIFICATION_TYPES,
  theme,
  tooltipContent,
} from "../config/DocumentConfig";
import { calculateRowValues } from "../config/PurchaseInvoiceTableConfig";
import { Box, IconButton, Tab, ThemeProvider, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import ModeIndicator from "../salesInvoice/ModeIndicator";
import { useLocation, useNavigate } from "react-router-dom";
import useApi from "../../utils/useApi";
import { getTodayDate } from "../../utils/constants";
import { purchaseData } from "../salesInvoice/data";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TimelineTab from "../salesInvoice/TimelineTab";
import PurchaseOrderTermsAndDelivery from "../purchaseOrder/PurchaseOrderTerms";
import PurchaseOrderTable from "../purchaseOrder/PurchaseOrderTable";
import ConfigCard from "../salesInvoice/ConfigCard";
import SummaryTotalCard from "../salesInvoice/SummaryTotalCard";
import Modal from "../common/CommonModal";
import ModificationCommentModal from "../salesInvoice/ModificationCommentModal";
import { Loader, Save, View } from "lucide-react";

const PurchaseReturn = ({ documentType = DOCUMENT_TYPES.PURCHASE_RETURN }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { request } = useApi();
  const config = getDocumentConfig(documentType);

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  const CURRENT_USER_OBJECT = localStorage?.getItem("currentUser")
    ? JSON.parse(localStorage?.getItem("currentUser"))
    : {};
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const INVMETHOD = CURRENT_USER_OBJECT[0]?.invMethod;
  const todayDate = getTodayDate();
  const documentNoFromState = location?.state?.docNo || null;
  console.log("Document Number From State in Purchase Return", documentNoFromState);
  const modeFromState = location?.state?.mode || "new";
  const [isSaving, setIsSaving] = useState(false);
  const [mode, setMode] = useState(modeFromState);

  const [parentTabValue, setParentTabValue] = useState("1");
  const [supplierData, setSupplierData] = useState(null);
  console.log("Supplier Data in Purchase Return", supplierData);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [items, setItems] = useState(purchaseData);
  const [currentLocation, setCurrentLocation] = useState("MAIN SHOP");
  const [showSidebar, setShowSidebar] = useState(false);
  const [initialRowUnitOptions, setInitialRowUnitOptions] = useState({});
  const [accountData, setAccountData] = useState(null);

  const [discountAmount, setDiscountAmount] = useState("");
  const [roundOff, setRoundOff] = useState("");

  const [autoVatIsOn, setAutoVatIsOn] = useState(true);
  const [vatAmountManual, setVatAmountManual] = useState(null);
  const [transferModalOpen, setIsTransferModalOpen] = useState(false);
  const [isModificationModalOpen, setIsModificationModalOpen] = useState(false);
  const [transferInvNo, setTransferInvNo] = useState("");
  const handleParentTabChange = (event, newValue) => {
    setParentTabValue(newValue);
  };
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

  const [documentData, setDocumentData] = useState({
    purchaseType: config.defaultValues.purchaseType || "Local",
    vatStatus: "VAT Applied",
    documentNo: "",
    date: todayDate,
    paymentMode: "cash",
    invNo: "",
    supplier: "",
    unregSupplier: "",
    trn: "",
    dueDays: "",
    dueDate: todayDate,
    cfAgent: "",
    shipRef: "",
    docDate: todayDate,
    jobCode: "",
    remarks: "",
    currency: "AED",
    currencyRate: "1",
    voucherType: "",
    creditAcc: "",
    debitAcc: "",
    invNumber: "",
    vatAcc: "",
    delivery: "",
    terms: "",
    lcNo: "",
    shipDate: todayDate,
    vehicleNo: "",
    drivername: "",
    primaryErrorField: "",
    nextAction: "",
  });
  const [glSettings, setGlSettings] = useState([]);

  useEffect(() => {
    const fetchGLSettings = async () => {
      try {
        const url = `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/SCRN_CODE/SI/-/${DEPARTMENT}/-`;
        const res = await fetch(url);
        const data = await res.json();
        setGlSettings(data || []);
      } catch (err) {
        console.error("Failed to fetch GL settings for COS", err);
        setGlSettings([]);
      }
    };
    fetchGLSettings();

  }, [documentType, BASE_URL, COMPANY_CODE, DEPARTMENT]);


  const fetchDocumentDetail = async (documentNo) => {
    try {
      const url = config.apiEndpoints.detail(
        COMPANY_CODE,
        documentNo,
        DEPARTMENT
      );
      const fullUrl = `${BASE_URL}${url}`;
      const res = await fetch(fullUrl);
      const response = await res.json();

      if (!response || response.length === 0) return;

      const header = response[0];
      const currencyRate = header.rate != null ? String(header.rate) : "1";

      setDocumentData((prev) => ({
        ...prev,

        documentNo: String(header.pr_no ?? ""),
        date: header.pr_date ? header.pr_date.slice(0, 10) : prev.date,
        dueDate: header.due_date ? header.due_date.slice(0, 10) : prev.dueDate,

        supplier: header.cust_acc || "",
        unregSupplier: header.consignee || "",
        creditAcc: header.cust_acc || "",
        debitAcc: header.cust_acc || "",
        trn: header.governor || "",

        invNo: String(header.tr_refno ?? ""),
        invNumber: header.pr_ref_no || "",
        voucherType: header.inv_type || prev.voucherType,

        currency: header.fc || "AED",
        currencyRate,

        remarks: header.comments || "",
        discountAmount: 0,
        roundOff: header.e || 0,

        vatStatus: header.client_pd || "VAT Applied",

        jobCode: header.job_code || "",
        purchaseType: header.cashcred === "R" ? "Local" : "Import",

        terms: header.payment || "",
        delivery: header.foot1 || "",
        shipRef: header.pr_ref_no || "",
        cfAgent: header.validity || "",
        lcNo: header.lpo_no || "",

        vehicleNo: header.Reason_of_Return || "",
        drivername: header.Condition_of_Part || "",
        primaryErrorField: header.Primary_error || "",
        nextAction: header.NextAction || "",
      }));

      const supplierObj = {
        ACCOUNT: header.cust_acc,
        DESCRIPTION: header.tr_desc || header.custref || "",
        TRN: header.CCNO || "",
      };

      setSupplierData(supplierObj);
      setSelectedSupplier(supplierObj);
      setTransferInvNo(header.tr_refno || "")
      const mappedItems = response.map((row, index) => ({
        id: index + 1,
        sino: index + 1,
        code: row.code || "",
        description: row.idesc || "",
        location: row.locn || "",
        unit: row.unit || "",
        qty: Number(row.tr_qty || row.tr_qty2) || 0,
        unitCost: Number(row.unit_price || row.unit_cost) || 0,
        amount: Number(row.line_total || row.fline_tota) || 0,
        vatEnabled: true,
        vatPercent: VATPERCENTAGE,
        vatAmount: Number(row.fraction2) || 0,
        total: (Number(row.line_total || row.fline_tota) || 0) + (Number(row.fraction2) || 0),
        remarks: row.remarks || "",
        pono: String(row.PO_NO || row.lpo_no || ""),
        oem: row.oem || "",
        fraction: Number(row.fraction) || 1,
        // "Discount%": Number(row.bcdisc) || 0,
        bin: row.batch || "",
        isIncluded: true,
        isActive: "Yes",
      }));

      setItems(mappedItems);
    } catch (err) {
      console.error(`Failed to fetch ${config.title} detail:`, err);
    }
  };

  const initializeDocument = useCallback(async () => {
    try {
      const { voucherType, documentNo } = await fetchDocumentNumber(
        documentType,
        documentData.paymentMode,
        BASE_URL,
        COMPANY_CODE,
        DEPARTMENT
      );

      if (documentNo) {
        setDocumentData((prev) => ({
          ...prev,
          documentNo: documentNo,
          voucherType,
        }));
      }
      console.log("Voucher Type:", voucherType, documentNo);
    } catch (err) {
      console.error("Error initializing document:", err);
    }
  }, [
    documentType,
    documentData?.paymentMode,
    BASE_URL,
    COMPANY_CODE,
    DEPARTMENT,
  ]);

  useEffect(() => {
    if (documentNoFromState) {
      fetchDocumentDetail(documentNoFromState);
    }
  }, [documentNoFromState, documentType]);

  useEffect(() => {
    if (mode === "new" && documentData.paymentMode) {
      // ensure paymentMode exists
      initializeDocument();
    }
  }, [mode, initializeDocument, documentData.paymentMode]);

  const getVatPercent = (documentData) =>
    documentData.vatStatus === "VAT Applied" ? VATPERCENTAGE : 0;

  const calculateTotals = () => {
    const round = (val) => Math.round(Number(val) * 100) / 100;

    const processedItems = items.map((item) =>
      calculateRowValues(item, documentData, {
        items,
      })
    );

    const rowTaxableSum = round(
      processedItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    );

    const rowVatSum = round(
      processedItems.reduce(
        (sum, item) => sum + (Number(item.vatAmount) || 0),
        0
      )
    );
    const grossAmount = round(
      processedItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0)
    );

    const globalDiscount = Number(discountAmount) || 0;
    const roundOffValue = Number(roundOff) || 0;

    const taxableAmount = round(rowTaxableSum - globalDiscount - roundOffValue);

    const totalVat =
      !autoVatIsOn && vatAmountManual !== null
        ? round(vatAmountManual)
        : rowVatSum;

    const totalAmount = round(taxableAmount + totalVat);

    const netAmount = round(totalAmount);

    const currencyRate = Number(documentData.currencyRate) || 1;
    const bcAmt = round(netAmount * currencyRate);

    return {
      grossAmount: grossAmount.toFixed(2),
      taxableAmount: taxableAmount.toFixed(2),
      vatAmount: totalVat.toFixed(2),
      discountAmount: globalDiscount.toFixed(2),
      roundOff: roundOffValue.toFixed(2),
      netAmount: netAmount.toFixed(2),
      // advanceAmount: advance.toFixed(2),
      bcAmt: bcAmt.toFixed(2),
    };
  };
  // Credit limit check helper functions
  async function fetchRefCount(accountId) {
    try {
      const res = await fetch(
        `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/PENDBILL/${accountId}/-`
      );
      const data = await res.json();
      return Number(data?.[0]?.RefCount || 0);
    } catch (err) {
      console.error("Error fetching RefCount:", err);
      return 0;
    }
  }
  const totals = calculateTotals();
  function isCreditLimitExceeded(accountData, totalAmount, refCount = 0) {
    const creditMethod = String(accountData?.CREDITMETHOD || "").toUpperCase();
    const isCreditCustomer = documentData?.paymentType === "credit";

    const isBlocked = creditMethod === "BLOCKED";
    const isCreditBlock = creditMethod === "CREDIT BLOCK";
    const isOpen = creditMethod === "OPEN";

    const dr = Number(accountData?.debit ?? accountData?.dr ?? 0);
    const cr = Number(accountData?.credit ?? accountData?.cr ?? 0);
    const balance = dr - cr;

    const pendbill = Number(accountData?.discount || 0);
    const duedays = Number(accountData?.duedays || 0);
    const ddays = Number(accountData?.ddays || 0);

    if (!isCreditCustomer) {
      return { blocked: false, exceeded: false, overdue: false, balance };
    }

    if (isOpen) {
      return { blocked: false, exceeded: false, overdue: false, balance };
    }

    if (isBlocked) {
      return { blocked: true, exceeded: false, overdue: false, balance };
    }

    if (isCreditBlock && totalAmount > balance) {
      return { blocked: false, exceeded: true, overdue: false, balance };
    }

    if (ddays > 0 && duedays > ddays) {
      return { blocked: false, exceeded: false, overdue: true, balance };
    }

    if (pendbill > 0 && refCount > pendbill) {
      return { blocked: false, exceeded: true, overdue: false, balance };
    }

    return { blocked: false, exceeded: false, overdue: false, balance };
  }

  // Credit limit validation
  useEffect(() => {
    if (!accountData?.CREDITMETHOD) return;

    const runChecks = async () => {
      const totalAmount = Number(totals?.totalAmount) || 0;
      const isCreditCustomer = documentData?.paymentType === "credit";

      if (!isCreditCustomer) return;

      const pendbill = Number(accountData?.discount || 0);
      const refCount =
        pendbill > 0 ? await fetchRefCount(accountData?.account) : 0;

      const { blocked, exceeded, overdue } = isCreditLimitExceeded(
        accountData,
        totalAmount,
        refCount
      );

      if (blocked) {
        alert("This account is BLOCKED");
        return;
      }

      if (overdue) {
        alert("Customer Bill Overdue");
        return;
      }

      if (exceeded) {
        alert("Credit Limit Exceeded");
        return;
      }
    };

    runChecks();
  }, [totals?.totalAmount, accountData, documentData?.paymentType]);

  const handleSave = async () => {
    try {
      setIsSaving(true);

      const filteredItems = items.filter(
        (item) => item.code && item.code.trim() !== ""
      );

      if (filteredItems.length === 0) {
        alert("Please add at least one item to the purchase return.");
        setIsSaving(false);
        return;
      }

      if (!supplierData || !supplierData.ACCOUNT) {
        alert("Please select a supplier before saving.");
        setIsSaving(false);
        return;
      }
      if (!documentData.documentNo) {
        alert("Document number is missing.");
        setIsSaving(false);
        return;
      }

      if (!documentData.trn || documentData.trn.length !== 15) {
        alert("Please enter a valid TRN (15 digits).");
        setIsSaving(false);
        return;
      }

      const missing = [];
      const reason = (documentData?.vehicleNo || "").toString().trim();
      const condition = (documentData?.drivername || "").toString().trim();
      const primaryError = (documentData?.primaryErrorField || "").toString().trim();
      const nextAction = (documentData?.nextAction || "").toString().trim();

      if (!reason) missing.push("Reason of Return");
      if (!condition) missing.push("Condition of Part & Packing");
      if (!primaryError) missing.push("Primary Error Source / Cause");
      if (!nextAction) missing.push("Next Action");

      if (missing.length > 0) {
        alert(
          "Please fill the following required fields for Purchase Return:\n\n" +
          missing.join("\n"),
        );
        setIsSaving(false);
        return;
      }

      const requestPayload = filteredItems.map((item, index) => {
        const processedItem = calculateRowValues(item, documentData, { items });

        const qty = Number(item.qty) || 0;
        const unitCost = Number(item.unitCost) || 0;
        const discPerc = Number(item["Discount%"]) || 0;
        const lineDiscAmt = qty * unitCost * (discPerc / 100);

        return {
          cmpcode: COMPANY_CODE,
          modeop: mode === "edit" ? "EDIT" : "SAVE",
          cashcustomer: "no",
          pr_no: documentData.documentNo || "",
          cust_acc: supplierData?.ACCOUNT || "",
          pr_total: (Number(totals?.netAmount) || 0).toFixed(2),
          pr_cost: "0",
          pr_ref_no: documentData.invNumber || "0", //Supplier inv number
          comments: documentData.remarks || "",
          disc_amt: String(Number(discountAmount) || 0),
          sale_man: CURRENT_USER_OBJECT[0]?.user || "",
          pr_tr_ref: documentData.invNumber || "0", //Supplier inv number
          do_no: documentData.invNo || "0", //transfered purchase inv
          due_date: documentData.dueDate || todayDate,
          area_code: "",
          type: "",
          do_data: "",
          q_no: "0",
          inv_type: "",
          user_id: CURRENT_USER || "",
          fdisc_amt: "0",
          costc: "",
          job_code: documentData.jobCode || "",
          pr_fctota: "0",
          fc: documentData.currency || "AED",
          awb: "",
          blno: "",
          pkg: "",
          rate2: "0",
          rate: Number(documentData.currencyRate) || 1,
          invcurr: "",
          supl_code: "",
          status: "",
          tr_refno: documentData.invNo || "", //transfered purchase inv
          payment: "credit",
          manuf: "",
          origin: "",
          shipment: "",
          delivery: "",
          packing: "",
          netwt: "",
          grosswt: "",
          insurance: "",
          custom: "",
          validity: "",
          foot1: "",
          frdet:
            INVMETHOD === "COS" &&
              (documentType === DOCUMENT_TYPES.SALES_INVOICE ||
                documentType === DOCUMENT_TYPES.SALES_RETURN)
              ? glSettings.find((g) => g.Scrn_code === "SI-COG-D")?.ACCOUNT ||
              ""
              : "",
          fruprice: "0",
          framt: "0",
          fob: "",
          repeat:
            INVMETHOD === "COS" &&
              (documentType === DOCUMENT_TYPES.SALES_INVOICE ||
                documentType === DOCUMENT_TYPES.SALES_RETURN)
              ? glSettings.find((g) => g.Scrn_code === "SI-STK-C")?.ACCOUNT ||
              ""
              : "",
          comm: "0",
          date_paid: todayDate,
          commdue: "0",
          comm_paid: "0",
          commp: "0",
          type_no: "0",
          paid_amt: "0",
          client_pd: documentData.vatStatus || "VAT Applied",
          tel: "",
          custref: supplierData?.DESCRIPTION || "",
          terms: "0",
          deptno: DEPARTMENT,
          month: "",
          cashcred: "", //import or LOCAL
          pr_date: documentData.date || todayDate,
          so_no: "0",
          sys_date: todayDate,
          comm_pd_dt: todayDate,
          pump: "",
          governor: documentData.trn || "",
          feedpump: "",
          injector: "",
          starter: "",
          enginetype: "CASH",
          date_prom: todayDate,
          date_delvd: todayDate,
          ret_qty: "0",
          rcvd_amt: "0",
          time: "",
          lab_charge: "0",
          oth_charge: 0,
          s:
            documentType === DOCUMENT_TYPES.SALES_INVOICE ||
              documentType === DOCUMENT_TYPES.SALES_RETURN
              ? INVMETHOD
              : "",
          m: "0",
          d: "0",
          e: roundOff?.toString() || "0",
          w: String(Number(totals?.vatAmount) || 0),
          wa: autoVatIsOn ? "0" : "1",
          pgroup: "",
          upd: "",
          do_date: todayDate,
          lpo_date: todayDate,
          Reason_of_Return: documentData.vehicleNo || "",
          Condition_of_Part: documentData.drivername || "",
          Primary_error: documentData.primaryErrorField || "",
          NextAction: documentData.nextAction || "",
          cap: "PR",
          salesacc: "",
          salesAccDesc: "",

          Slno: index + 1,
          code: item.code || "",
          description: item.description || "",
          locn: item.location || "",
          unit: item.unit || "",
          qty: String(qty),
          "Unit Price": String(Number(item.unitPrice || item.UnitPrice || unitCost) || 0),
          "Disc%": String(discPerc),
          Ldisc_amt: String(Math.round(lineDiscAmt * 100) / 100),
          Amount: String(Number(processedItem.amount) || 0),
          x: item.x || "",
          cntrl: item.cntrl || "",
          Fraction: String(Number(item.fraction) || 1),
          "vat%": Number(getVatPercent(documentData)),
          "Unit Cost": String(unitCost),
          dono: "0",
          sono: "0",
          quotno: "0",
          Avlqty: "0",
          Vatamt: String(Number(processedItem.vatAmount) || 0),
          BDiscsplit: "0",
          total: String(Number(processedItem.total) || 0),
          oem: item.oem || "",
          Bin: item.bin || "",
          rcvd_mode1: "",
          rcvd_mode1_acc: "",
          rcvd_mode1_amt: 0,
          rcvd_mode2: "",
          rcvd_mode2_acc: "",
          rcvd_mode2_amt: 0,
          commi_acc_Dr: "",
          commi_acc_Cr: "",
          commi_amt: 0,
          shipping_type: "Shipping Charges",
          shipping_amt: 0,
        };
      });

      console.log("Purchase Return Payload:", requestPayload);
      // return
      // Send to API
      const apiUrl = `${BASE_URL}${config.apiEndpoints.save}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestPayload),
      });

      const result = await response.json();
      console.log("API Response:", result);

      if (response.ok && result) {
        const prNumber = result[0]?.pr_no || documentData.documentNo;
        alert(`Purchase Return #${prNumber} saved successfully!`);

        // Navigate to purchase return list
        navigate("/purchase_return_list");
      } else {
        alert(
          `Failed to save Purchase Return: ${result?.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error saving Purchase Return:", error);
      alert(`Error saving Purchase Return: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };
  const handlePrint = async () => {
    // console.log("Print Logged");
    // alert("Document Printed Successfully");
    navigate("/purchase_order_list");
  };

  const handleTransfer = async (docType, selectedRows) => {
    setIsTransferModalOpen(false);
    console.log("Selected rows from Parent component", selectedRows);
    const docNos = selectedRows
      .map((row) => {
        return (
          row.QUOTNO ||
          row.inv_no ||
          row.ORDNO ||
          row.do_no ||
          row.SONO ||
          row.PONO
        );
      })
      .join(",");
    console.log("Doc number transfered", docNos);
    const masterUrl = `${BASE_URL}${config.apiEndpoints.transfer.master(
      COMPANY_CODE,
      DEPARTMENT,
      docNos,
      docType
    )}`;
    const detailUrl = `${BASE_URL}${config.apiEndpoints.transfer.detail(
      COMPANY_CODE,
      DEPARTMENT,
      docNos,
      docType
    )}`;

    try {
      const masterRes = await fetch(masterUrl);
      const masterData = await masterRes.json();
      console.log("Master Transfer Response:", masterData);

      if (masterData && masterData.length > 0) {
        const totalDiscount = masterData?.reduce(
          (acc, row) => acc + (row.so_disc || 0),
          0
        );
        const main = masterData[0];

        setDocumentData((prev) => ({
          ...prev,
          supplier: main.cust_acc,
          salesman: main.sale_man?.trim(),
          so_ref: main.so_ref,
          areacode: main.area_code,
          duedate: main.due_date?.slice(0, 10),
          terms: "0",
          date: main.so_date?.slice(0, 10),
          paymentType: "credit",
          currency: main.fc,
          currencyRate: main.so_fcrate || 1,
          remarks: main.comments || "",
        }));

        setDiscountAmount(totalDiscount);
      }

      const detailRes = await fetch(detailUrl);
      const detailData = await detailRes.json();
      console.log("Detail Transfer Response:", detailData);
      // Item mapping for transfered data
      if (detailData && detailData.length > 0) {
        const items = detailData.map((row, idx) => ({
          id: idx + 1,
          sino: idx + 1,
          code: row.code || row.po_icode || row.so_icode || row.idesc,
          description: row.idesc,
          location: row.po_locn || row.locn,
          unit: row.unit?.trim(),
          qty: row.po_qty || row.so_qty,
          unitCost: row.cost_unit || row.so_fccost,
          UnitCost: String(Number(row.cost_unit) || 0),
          discount: row.po_fdisc || row.so_disc || row.so_fdisc,
          fraction: row.fraction,
        }));

        const initialRowUnitOptions = await fetchUnitOptionsForItems(
          items,
          BASE_URL,
          COMPANY_CODE
        );
        setItems(items);
        setInitialRowUnitOptions(initialRowUnitOptions);
      }
    } catch (err) {
      console.error("Error fetching transfer data:", err);
    }
  };
  const onPickItems = async (invNo, selectedItemRows = []) => {
    console.log("InvNo", invNo);
    console.log("SelectedItemRows", selectedItemRows);

    if (!selectedItemRows || selectedItemRows.length === 0) return;

    const firstRow = selectedItemRows[0];
    const account = firstRow?.account?.trim();
    const accdesc = firstRow?.accdesc?.trim();
    const invRef = firstRow?.inv || "";
    const invDate = firstRow?.date ? firstRow.date.slice(0, 10) : todayDate;
    const dueDate = firstRow?.duedate ? firstRow.duedate.slice(0, 10) : todayDate;
    const currency = firstRow?.fc || "AED";
    const currencyRate = firstRow?.rate || 1;

    if (account) {
      const supplierObj = { ACCOUNT: account, DESCRIPTION: accdesc };
      setSupplierData(supplierObj);
      setSelectedSupplier(supplierObj);
    }

    setDocumentData((prev) => ({
      ...prev,
      inv_no: invNo,
      invNo: invNo,
      invNumber: invRef,
      date: invDate,
      dueDate,
      currency,
      currencyRate: String(currencyRate),
      purchaseType: firstRow?.local === 'L' ? 'Local' : 'Import'
    }));
    setTransferInvNo(invNo);
    const mappedItems = selectedItemRows.map((row, idx) => {
      const qty = Number(row.tr_qty) || 0;
      const unitCost = Number(row.unit_price || row.funit_pric) || 0;
      // const discountPerc = Number(row.bcdisc) || 0;
      const amount = qty * unitCost;
      const vatAmount = Number(row.vatamt) || 0;
      const total = amount + vatAmount;

      return {
        id: idx + 1,
        sino: idx + 1,
        code: row.code || "",
        description: row.idesc || "",
        location: row.locn || "",
        unit: row.unit || "",
        qty,
        unitCost,
        unitBCCost: Number(row.unit_price || 0) || 0,
        amount,
        othCost: Number(row.POTHERCOST) || 0,
        x: row.x || 0,
        cntrl: row.soguid || 0,
        fraction: Number(row.FRACTION) || 1,
        vatEnabled: true,
        vatPercent: VATPERCENTAGE,
        vatAmount,
        mastInfo: "",
        pono: String(row.PO_NO || ""),
        total,
        oem: "",
        group: "",
        "Discount%": 0,
        git: "",
        salesperson: "",
        bin: row.BATCH || "",
        remarks: row.remarks || "",
        dcp: "",
        isIncluded: true,
        soUid: "",
        isActive: "Yes",
      };
    });

    setItems(mappedItems);
    setIsTransferModalOpen(false);
  }
  return (
    <div className="w-full relative">
      <div className="flex items-center justify-between lg:px-10 px-2 mb-2 gap-2">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold">{config.title}</h1>
        </div>

        <Tooltip title={tooltipContent} sx={{ margin: 0, padding: 0 }}>
          <IconButton>
            <HelpOutline
              className="text-blue-600 bg-white rounded-full"
              fontSize="medium"
            />
          </IconButton>
        </Tooltip>
      </div>

      <ModeIndicator mode={mode} documentType={documentType} />

      <div className="w-full rounded-lg">
        <div className="lg:px-10">
          <div className="bg-gray-50 border lg:p-3 rounded-lg shadow pb-6">
            <ThemeProvider theme={theme}>
              <TabContext value={parentTabValue}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <TabList onChange={handleParentTabChange}>
                    <Tab label="General" value="1" sx={{ padding: 0 }} />
                    <Tab
                      label="Terms & Delivery"
                      value="2"
                      sx={{ padding: 0 }}
                    />
                    <Tab label="Timeline" value="3" sx={{ padding: 0 }} />
                  </TabList>
                  <div className="lg:flex hidden items-center gap-3">
                    <button
                      //   onClick={handlePrint}
                      onClick={() => {
                        navigate("/purchase_return_list");
                      }}
                      className="flex items-center gap-2 px-5 py-2.5 border border-indigo-600 text-indigo-600 text-sm font-medium rounded-lg shadow hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <View className="w-4 h-4" />
                      View
                    </button>
                    <button
                      onClick={() => {
                        if (mode === "edit") {
                          setIsModificationModalOpen(true);
                        } else {
                          handleSave();
                        }
                      }}
                      disabled={mode === "view" || isSaving}
                      className="flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white text-sm font-medium rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSaving ? (
                        <>
                          <Loader className="w-4 h-4 animate-spin" />
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="w-4 h-4" />
                          {mode === "edit" ? "Update" : "Save"}
                        </>
                      )}
                    </button>
                  </div>
                </Box>
                <TabPanel value="1" sx={{ p: 0, paddingX: 0 }}>
                  <PurchaseReturnGeneral
                    purchaseOrderData={documentData}
                    setPurchaseOrderData={setDocumentData}
                    COMPANY_CODE={COMPANY_CODE}
                    DEPARTMENT_NO={DEPARTMENT}
                    BASE_URL={BASE_URL}
                    setSupplierData={setSupplierData}
                    selectedSupplier={selectedSupplier}
                    setSelectedSupplier={setSelectedSupplier}
                    supplierData={supplierData}
                    documentType="PURCHASEORDER"
                  />
                </TabPanel>
                <TabPanel value="2" sx={{ p: 0, paddingX: 0 }}>
                  <PurchaseOrderTermsAndDelivery
                    purchaseOthersData={documentData}
                    setPurchaseOthersData={setDocumentData}
                  />
                </TabPanel>
                <TabPanel value="3" sx={{ p: 1 }}>
                  <TimelineTab
                    BASE_URL={BASE_URL}
                    DEPARTMENT={DEPARTMENT}
                    modificationType={MODIFICATION_TYPES[documentType] || null}
                    invoiceId={documentNoFromState}
                    COMPANY_CODE={COMPANY_CODE}
                  />
                </TabPanel>
              </TabContext>
            </ThemeProvider>
          </div>
        </div>

        <main className="w-full mt-4 relative">
          <PurchaseOrderTable
            items={items}
            onItemsChange={setItems}
            setShowSidebar={setShowSidebar}
            // setItemInfo={setItemInfo}
            setCurrentLocation={setCurrentLocation}
            extraFields={[]}
            purchaseData={documentData}
            initialRowUnitOptions={initialRowUnitOptions}
            setInitialRowUnitOptions={setInitialRowUnitOptions}
            // isOtherCostEnabled={false}
            // setIsOtherCostEnabled={setIsOtherCostEnabled}
            // otherCosts={otherCosts}
            // setOtherCosts={setOtherCosts}
            calculateRowValues={calculateRowValues}
            invoiceData={documentData}
            getVatPercent={getVatPercent}
            BASE_URL={BASE_URL}
            COMPANY_CODE={COMPANY_CODE}
            DEPARTMENT_NO={DEPARTMENT}
          />
        </main>
        <div className="w-full lg:px-10 p-1 mt-2">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
            <ConfigCard
              invoiceData={documentData}
              setAutoVatIsOn={setAutoVatIsOn}
              setInvoiceData={setDocumentData}
              autoVatIsOn={autoVatIsOn}
              documentType={documentType}
              config={config}
              setIsModalOpen={setIsTransferModalOpen}
              isModalOpen={transferModalOpen}
              fetchDocumentDetail={fetchDocumentDetail}
              invoiceNoFromState={documentNoFromState}
              accountData={supplierData}
              onTransfer={handleTransfer}
              onPickItems={onPickItems}
              transferInvNo={transferInvNo}
            />

            <SummaryTotalCard
              totals={totals}
              setInvoiceData={setDocumentData}
              invoiceData={documentData}
              handlePrint={handlePrint}
              handleSave={handleSave}
              roundOff={roundOff}
              setRoundOff={setRoundOff}
              discountAmount={discountAmount}
              setDiscountAmount={setDiscountAmount}
              mode={mode}
              autoVatIsOn={autoVatIsOn}
              setVatAmountManual={setVatAmountManual}
              config={config}
              setIsModificationModalOpen={setIsModificationModalOpen}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModificationModalOpen}
        onClose={() => setIsModificationModalOpen(false)}
        size="md"
        header={true}
        title="Update Confirmation"
        showFullScreen={false}
      >
        <ModificationCommentModal
          isOpen={isModificationModalOpen}
          onClose={() => setIsModificationModalOpen(false)}
          handleSave={handleSave}
          documentData={documentData}
          documentType={documentType}
          COMPANY_CODE={COMPANY_CODE}
          DEPARTMENT={DEPARTMENT}
          CURRENT_USER={CURRENT_USER}
          BASE_URL={BASE_URL}
          setIsModificationModalOpen={setIsModificationModalOpen}
        />
      </Modal>
    </div>
  );
};

export default PurchaseReturn;
